export enum PlanningKpiType {
  CONTRACTS_CREATED = 1,
  PLANNED_HOURS = 2,
}
